module.exports = __webpack_public_path__ + "img/68493E_B2AAA9_978C8C_130907-256px.4594db5d.png";